import env from '@/env';

export const titlePrefix = env.VITE_TITLE_PREFIX ? `${env.VITE_TITLE_PREFIX} · ` : '';
